"use strict";
/**
 * @classdesc
 * ALKIS Vektordaten-Export-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}]
 * @param {Array} options.formats unterstützte Exportformate
 * @param {number} options.maxScale Maximaler Maßstab, für den der Export zur Verfügung stehen soll.
 * @param {string} [options.label='ALKIS - Export Vektordaten']
 * @param {Object<string,*>} options.requests
 * @param {string} options.requests.exportUrl
 */
gc.gis.module.GCAlkisExport = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	var self = this;

	/**
	 * @type {Object<string,*>}
	 */
	this.options       = options;
	/**
	 * @type {gc.gis.map.GCMapView}
	 */
	this.map           = options.map || gc.gis.iface.map;
	/**
	 * @type {string}
	 */
	this.label         = options.label || 'ALKIS - Vektordaten-Export';
	/**
	 * @type {Array}
	 */
	this.formats = options.formats;
	/**
	 * Maximaler Maßstab, für den der Export zur Verfügung stehen soll.
	 * @type {number}
	 */
	this.maxScale = options.maxScale || 5000;
	/**
	 * @type {string}
	 */
	this.export_url = options.requests.exportUrl;


	this._render();

    // als Sub-Modul von Tools
    gc.gis.iface.onModuleAvailable(this, 'GCTools', function(module) {
        gc.gis.assert.isInstance(module, gc.gis.module.GCTools);
        self.launcher_content = module.addModule(self, this.getElement(), 'ms ms-layer-export');
    });
};
gc.gis.module.GCAlkisExport.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 * @return {jQuery}
 */
gc.gis.module.GCAlkisExport.prototype.getElement = function()
{
	return this.element_panel.getElement();
};

/**
 * @return {jQuery}
 */
gc.gis.module.GCAlkisExport.prototype._render = function()
{
	var self = this;

	this.element_panel = new gc.gis.module.GCAlkisExport.Panel({
		module: self,
		active: self.active,
		headline: self.label
	});
	return this.element_panel;
};

/**
 * Liefert eine Liste der unterstützten Exportformate.
 *
 * @return {Array}
 */
gc.gis.module.GCAlkisExport.prototype.getSupportedFormats = function()
{
	return this.formats;
};

/**
 * Exportiert die ALKIS-Daten in ein Vektorformat und gibt eine entsprechende Datei dem Nutzer zurück.
 *
 * @param {string} format
 * @param {boolean} within
 */
gc.gis.module.GCAlkisExport.prototype.exportData = function(format, within)
{
	var self = this;

	var params = {
		format: format,
		within: within ? 1 : 0,
		crs: this.map.getProjection(),
		geometry: this.map.getViewport().geometry
	};

	gc.gis.iface.request.download(self.export_url, {params: JSON.stringify(params)});
};
